export default "__VITE_ASSET__BYZeOJ1U__"